module.exports = __webpack_public_path__ + "media/images/favicon/android-icon-192x192-0e24982bae53c0f0337d158aa642714f.png";